import React from "react";
import { ValidatorForm } from "react-material-ui-form-validator";
import { Button, Grid, Divider, TextField, Typography } from "@mui/material";
import DOMHelper from "../../../../helpers/DOMHelper";
import useMessageNotifier from "../../../../helpers/hooks/component/useMessageNotifier";
import { useDispatch } from "react-redux";
import { updateUserMail } from "../../../../store/slices/accountSlice";
import { toggleLoading } from "../../../../store/slices/loadingSlice";
import UserService from "../../../../api/extranet/services/UserService";
import { useKeycloak } from "@react-keycloak/web";
import SubCard from "../../../berry/ui-component/cards/SubCard";

const EmailEditForm = ({ account }) => {
    const { showMessage } = useMessageNotifier();
    const dispatch = useDispatch();
    const { keycloak } = useKeycloak();
    const mainForm = React.useRef();
    const [state, setState] = React.useState({
        email: '',
        newEmail: '',
        confirmNewEmail: '',
    });

    React.useEffect(() => {
        setState((prevState) => ({
            ...prevState,
            email: account.user.email
        }));
    }, [account]);

    const handleChange = (event) => {
        const { name, value } = event.target;

        setState((prevState) => ({
            ...prevState,
            [name]: (name === "newEmail" || name === "confirmNewEmail")
                ? value.toLowerCase()
                : value
        }));
    };

    const callUpdateEmail = async () => {
        dispatch(toggleLoading());
        const resultCall = await UserService.updateUserEmail(keycloak.token, account.user.extranetUuid, { email: state.newEmail });
        dispatch(toggleLoading());
        return resultCall;
    };

    const handleSubmit = () => {
        mainForm.current.isFormValid(false).then(async (valid) => {
            if (valid) {
                const resultCall = await callUpdateEmail();
                if (resultCall.code === 200) {
                    setState((prevState) => ({
                        ...prevState,
                        newEmail: '',
                        confirmNewEmail: ''
                    }));
                    dispatch(updateUserMail({
                        email: state.confirmNewEmail
                    }));
                    showMessage(resultCall.message, 'success');
                } else {
                    showMessage(resultCall.message, 'error');
                }
            } else {
                DOMHelper.scrollToError();
            }
        });
    };

    const isButtonDisabled = () => {
        const { newEmail, confirmNewEmail, email } = state;
        return !(
            newEmail &&
            confirmNewEmail &&
            newEmail === confirmNewEmail &&
            newEmail !== email
        );
    };

    const validateEmails = () => {
        const { newEmail, confirmNewEmail } = state;
        if (newEmail && confirmNewEmail) {
            if (newEmail !== confirmNewEmail) {
                return "Les deux adresses e-mail ne correspondent pas.";
            } else if (!/\S+@\S+\.\S+/.test(newEmail)) {
                return "Le format de l'adresse e-mail est incorrect.";
            }
        }
        return ""; // Return empty string if no error
    };

    return (
        <Grid item lg={6} xs={12}>
            <SubCard title="Mon e-mail">
                <Grid container spacing={2}>
                    <Divider sx={{ pt: 1 }} />
                    <Grid item xs={12}>
                        <ValidatorForm
                            ref={mainForm}
                            onSubmit={handleSubmit}
                            onError={() => console.error('onError')}
                        >
                            <TextField
                                fullWidth
                                label="Adresse e-mail"
                                name="email"
                                value={state.email}
                                disabled
                                margin="normal"
                                variant="outlined"
                            />
                            <TextField
                                fullWidth
                                label="J’indique une nouvelle adresse e-mail"
                                name="newEmail"
                                value={state.newEmail}
                                onChange={handleChange}
                                margin="normal"
                                variant="outlined"
                                type="email"
                            />
                            <TextField
                                fullWidth
                                label="Je confirme ma nouvelle adresse e-mail"
                                name="confirmNewEmail"
                                value={state.confirmNewEmail}
                                onChange={handleChange}
                                margin="normal"
                                variant="outlined"
                                type="email"
                            />
                            <Button
                                variant="contained"
                                type="submit"
                                color="secondary"
                                disabled={isButtonDisabled()}
                                sx={{ mt: 2, textTransform: 'none' }}
                            >
                                Je valide
                            </Button>

                            {/* Error Message Block */}
                            <Typography variant="body2" color="error" sx={{ mt: 2 }}>
                                {validateEmails()}
                            </Typography>
                        </ValidatorForm>
                    </Grid>
                </Grid>
            </SubCard>
        </Grid>
    );
};

export default EmailEditForm;
